import React, { useState } from "react";
import { Steps } from "antd";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import svg51 from "../../../assets/svg/svg51.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import ProductionStep from "./steps/ProductionStep";
import VarietiesStep from "./steps/VarietiesStep";
import IndicatorsStep from "./steps/IndicatorsStep";

function ProductionDataAdd() {
  const [current, setcurrent] = useState(0);

  const { activeObjProductionData } = useSelector((state) => ({
    activeObjProductionData: state.obj.activeObj["schemeProductionData"],
  }));

  function handleNext() {
    setcurrent(current + 1);
  }

  function handleBack() {
    setcurrent(current - 1);
  }

  const steps = [
    {
      title: "Production Data",
      content: <ProductionStep handleNext={handleNext} />,
      icon: <img src={svg51} alt="svg51" />,
    },
    {
      title: "Varieties",
      content: (
        <VarietiesStep handleNext={handleNext} handleBack={handleBack} />
      ),
      icon: <img src={svg51} alt="svg51" />,
    },
    {
      title: "Indicators",
      content: <IndicatorsStep handleBack={handleBack} />,
      icon: <img src={svg51} alt="svg51" />,
    },
  ];

  const items = steps.map((item) => ({
    key: item.key,
    title: item.title,
    icon: item.icon,
  }));

  return (
    <div className="w-full">
      <BreadCrumb
        breadcrumbs={[
          { title: "Scheme Production Data", path: "/production-data" },
          {
            title: activeObjProductionData?.id
              ? "Update Production Data"
              : "Register Production Data",
          },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="w-full">
          <div className="form-add-h !text-darkBlue">
            {activeObjProductionData?.id
              ? "Update Production Data"
              : "Register Production Data"}
          </div>
          <div className="proj_desc mt-[.25rem]">
            Select the scheme, financial year and crop, capture the varieties
            per season, then the remaining indicators.
          </div>

          <div className="mt-[2.5rem]">
            <Steps
              className=""
              current={current}
              labelPlacement="vertical"
              items={items}
              onChange={(value) => {
                // Steps 2 and 3 hang off the saved record, so block jumping
                // ahead until step 1 has been saved
                if (value > current && !activeObjProductionData?.id) {
                  toast.error(
                    "Kindly save the production data first before moving to the next step."
                  );
                  return;
                }
                setcurrent(value);
              }}
            />
          </div>

          <div className="mt-[2.12rem]">{steps[current].content}</div>
        </div>
      </div>
    </div>
  );
}

export default ProductionDataAdd;
